import { render } from "./WarmTransferAgentDropDown.vue?vue&type=template&id=486bf6e0"
import script from "./WarmTransferAgentDropDown.vue?vue&type=script&lang=js"
export * from "./WarmTransferAgentDropDown.vue?vue&type=script&lang=js"
script.render = render

export default script